import { render, staticRenderFns } from "./AboutHide.vue?vue&type=template&id=05317f78&scoped=true&"
import script from "./AboutHide.vue?vue&type=script&lang=js&"
export * from "./AboutHide.vue?vue&type=script&lang=js&"
import style0 from "./AboutHide.vue?vue&type=style&index=0&id=05317f78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05317f78",
  null
  
)

export default component.exports